import { render, staticRenderFns } from "./UserReportRatings.vue?vue&type=template&id=5c9ae0f6&scoped=true"
import script from "./UserReportRatings.vue?vue&type=script&lang=js"
export * from "./UserReportRatings.vue?vue&type=script&lang=js"
import style0 from "./UserReportRatings.vue?vue&type=style&index=0&id=5c9ae0f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9ae0f6",
  null
  
)

export default component.exports